import axios from 'axios'
import router from '@src/router'

export default {
  namespaced: true,
  state: {
    module: '',
    module2: '',
  },
  getters: {
    module(state) {
      return state.module
    },
    module2(state) {
      return state.module2
    },
  },
  mutations: {
    SET_MODULE(state, value) {
      state.module = value
    },
    SET_MODULE2(state, value) {
      state.module2 = value
    },
  },
  actions: {
    module({ commit }, { id }) {
      commit('SET_MODULE', id)
      router.push({ path: '/padel/multi-addons/module/' + id })
    },
    module2({ commit }, { id }) {
      commit('SET_MODULE2', id)
      // router.push({ path: '/schedule-addons/' + id + '?module=multi-addons' })
      router.push('/padel/schedule-addons/' + id + '?module=padel-multi-addons')
    },
    module3({ commit }, { id }) {
      commit('SET_MODULE2', id)
      // router.push({ path: '/schedule-addons/' + id + '?module=addons' })
      router.push('/padel/schedule-addons/' + id + '?module=padel-addons')
    }
  }
}